<template>
  <div class="app-container">
    <template v-if="$route.name !== 'Login'">
      <HeaderComponent />
      <div class="main-layout">
        <LeftSidebarComponent
          v-show="$route.meta?.showSidebar"
        />
        <main class="main-content">
          <router-view v-slot="{ Component, route: r }">
            <transition name="fade" mode="out-in">
              <keep-alive>
                <component :is="Component" :key="r.name" />
              </keep-alive>
            </transition>
          </router-view>
        </main>
      </div>
      <FooterComponent />
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import HeaderComponent from './components/HeaderComponent.vue';
import LeftSidebarComponent from './components/LeftSidebarComponent.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    LeftSidebarComponent,
    FooterComponent
  }
};
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main-layout {
  flex: 1;
  display: flex;
  min-height: 0;
  background: #f7f8fa;
  overflow: hidden;
}
.main-content {
  flex: 1;
  padding: 22px 24px 0px 24px;;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 0;
  max-height: 100%;
  overflow-y: auto;
}
/* 路由过渡动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

/* 响应式：主布局适配 */
@media (max-width: 1200px) {
  .main-layout { flex-direction: column; }
  .main-content { margin: 12px 0; padding: 16px 8px; border-radius: 10px; }
}
@media (max-width: 768px) {
  .main-content { padding: 12px; border-radius: 8px; }
}
</style>
